export default __webpack_public_path__ + "static/media/Q42020.b72b7a4a.PDF";